export enum GraphQLErrorMessages {
  USER_NOT_FOUND = 'user not found',
  INVALID_PHONE_NUMBER = 'invalid phone number',
}
